import React from 'react';

import { useIntl } from 'react-intl';

import { useCreateMembershipType } from 'src/features/membershipType/api/useCreateMembershipType';
import { LIST_MEMBERSHIP_TYPES_RESOURCE } from 'src/features/membershipType/api/useListMembershipTypes';
import MembershipTypeWizardForm from 'src/features/membershipType/components/wizard/MembershipTypeWizardForm';
import { membershipTypeMessages } from 'src/features/membershipType/utils/messages';
import { toast } from 'src/hooks/UseToast';
import { queryClient } from 'src/lib/react-query';
import { useParking } from 'src/providers/ParkingProvider';
import { DataTableNewEntryProps } from 'src/registry/components/table/types';
import { generalMessages } from 'src/registry/utils/messages';

interface MembershipTemplateFormModalProps<TData> extends DataTableNewEntryProps<TData> {
    children?: React.ReactNode;
}

function CreateMembershipTypeFormModal<TData>({ className, semantics }: MembershipTemplateFormModalProps<TData>) {
    const { formatMessage } = useIntl();

    const { parkingId } = useParking();
    const { mutate, isPending } = useCreateMembershipType({
        onSuccess: () => {
            void queryClient.invalidateQueries({ queryKey: [LIST_MEMBERSHIP_TYPES_RESOURCE] });
            toast({
                title: formatMessage(membershipTypeMessages.createTemplateSuccess),
                description: formatMessage(membershipTypeMessages.createTemplateSuccessDescription),
            });
        },
    });

    return (
        <MembershipTypeWizardForm
            className={className}
            mutate={(values, onSuccess, onError) => mutate({ parkingId, ...values }, { onSuccess, onError })}
            title={formatMessage(generalMessages.createEntry, { entry: semantics?.entryName?.toLowerCase() })}
            isPending={isPending}
        />
    );
}

export default CreateMembershipTypeFormModal;
